import getFormattedPriceWithoutDecimals from '@propertypal/shared/src/utils/property/getFormattedPriceWithoutDecimals';
import React from 'react';
import {
  RangeLine,
  StartMarker,
  MiddleMarker,
  EndMarker,
  LowerEstimateText,
  HigherEstimateText,
  LowerEstimateValue,
  HigherEstimateValue,
  MiddleEstimateValue,
} from './ValuationRange.style';

interface ValuationRangeProps {
  lowerEstimate: number | null;
  higherEstimate: number | null;
  middleEstimate: number | null;
}

const ValuationRange: React.FC<ValuationRangeProps> = ({ lowerEstimate, higherEstimate, middleEstimate }) => {
  return (
    <RangeLine>
      {lowerEstimate && <LowerEstimateValue>{getFormattedPriceWithoutDecimals(lowerEstimate)}</LowerEstimateValue>}
      <StartMarker />
      <LowerEstimateText>Lower Estimate</LowerEstimateText>
      {middleEstimate && <MiddleEstimateValue>{getFormattedPriceWithoutDecimals(middleEstimate)}</MiddleEstimateValue>}
      <MiddleMarker />
      {higherEstimate && <HigherEstimateValue>{getFormattedPriceWithoutDecimals(higherEstimate)}</HigherEstimateValue>}
      <EndMarker />
      <HigherEstimateText>Upper Estimate</HigherEstimateText>
    </RangeLine>
  );
};

export default ValuationRange;
